<template>
    <div class="page1-body">
        <div class="logo-area">
            <img :src="logo" />
        </div>
        <div class="main-title">
            1週間<span>無料</span>体験!!
        </div>
        <div class="sub-title">
            地上・BS・CS放送48局
        </div>

        <div class="min-title">
            海外で日本のテレビを観るアプリ！
        </div>
        <div class="image-area">
            <img :src="image" />
        </div>
        <div class="msg">
            スマホ、BOXなどマルチデバイス対応
        </div>
        <div class="buy-btn" @click="routerTo('/sendMessage')">
            <span>今すぐ無料お試し</span>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    },
    props:['logo','image'],
    methods: {
        routerTo (path) {
            this.$router.push(path)
        }
    }
}
</script>
<style scoped>
.page1-body {
    background-image: url('../../../images/page1-bg.png');
    background-position: center center;
    background-size: cover;
    width: 100%;
    padding-top: 60px;
    padding-bottom: 70px;
}
.logo-area {
    width: 100%;
}
.logo-area img {
    height: 35px;
    display: block;
    margin: 0 auto;
}
* {
    color: #fff;
    text-align: center;
}
.main-title {
    font-size: 40px;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 20px;
}
.main-title span {
    display: inline-block;
    color: #D91C76;   
}
.sub-title {
    font-size: 30px;
    font-weight: bold;
}
.min-title {
    font-size: 16px;
    margin-bottom: 30px;
}
.image-area img {
    display: block;
    margin: 0 auto;
    height: 70px;
}
.msg {
    margin-top: 20px;
    font-size: 15px;
}
.buy-btn {
    width: 229px;
    height: 46px;
    background: #FDB819;
    box-shadow: 0px 3px 0px 0px #885F01;
    border-radius: 7px;
    margin: 0 auto;
    line-height: 46px;
    margin-top: 40px;
}
.buy-btn span {
    font-size: 21px;
    font-family: A-OTF Gothic MB101 Pro;
    font-weight: bold;
    color: #FEFEFE;
    text-shadow: 0px 3px 0px #624400;
    line-height: 46px;
}
</style>